// PATH: src/routes/AuthRedirect.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useTilmiAuth } from "../hooks/useTilmiAuth";
import routeConfigs from "./routeConfig";
import Login from "../pages/auth/auth/Login";
import ChangePasswordRequired from "../pages/auth/auth/ChangePasswordRequired";

const AuthRedirect: React.FC = () => {
    const { status, isLoading, isRoleExist, user } = useTilmiAuth();

    if (isLoading || status === "unknown") {
        return null;
    }

    const getFirstAccessibleRoute = () => {
        for (const route of routeConfigs) {
            if (route.isProtected && route.requiredRoles) {
                if (route.requiredRoles.some((role: string) => isRoleExist(role))) {
                    return route.path;
                }
            }
        }
        for (const route of routeConfigs) {
            if (!route.isProtected) {
                return route.path;
            }
        }
        return "/access-denied";
    };

    if (status === "authenticated") {
        // Mot de passe provisoire : intercepte AVANT la redirection. Sans cela,
        // un compte dont la premiere route accessible serait publique
        // echapperait au garde de ProtectedRoute.
        if (user?.user?.must_change_password) {
            return <ChangePasswordRequired />;
        }
        const firstAccessibleRoute = getFirstAccessibleRoute();
        return <Navigate to={firstAccessibleRoute} />;
    }

    return <Login />;
};

export default AuthRedirect;
